//FUNCIONS
import React, { useCallback, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { StoreState } from '../../../../store/createStore';
import { findStoreAll, openShowModal, setMultistoreSelected, storeSelectedRequest } from '../../../../store/modules/parameter/actions';

//HOOKS
import { useCheckoutInfo } from '../../../../hooks/useCheckoutInfo';

//TYPES
import { Store } from '../../../../store/modules/parameter/types';
//COMPONENTS

//STYLES
import {
  AddressName,
  ContainerAddressRow,
  ContainerAddress,
  ContainerAddressList,
  AddressAddress,
} from './styles';
import Loading from '../../../../components/Loading';
import { Container } from '../../styles';
import { config } from '../../../../config';
import { clearProducts, setProductFilter } from '../../../../store/modules/product/actions';
import { useLocation } from 'react-router-dom';
import { routesEndpoints } from '../../../../routes/endpoint';
import { uploadCheckout } from '../../../../store/modules/checkout/actions';

const AddressStoreModal: React.FC = () => {
  const location = useLocation();
  const { stores, loading, multistoreSelected } = useSelector((state: StoreState) => state.parameter);
  const dispatch = useDispatch();
  const { onSetSelShipping, onSetaddressSelect } = useCheckoutInfo();
 
  useEffect(() => {
    dispatch(findStoreAll());
  }, [dispatch]);

  const handleadSelectStore = useCallback(async (store: Store) => {
    if (config.isAllowedMultistore) {
      if (multistoreSelected.store_id !== store.store_id) {
        dispatch(setProductFilter({
          page: 1,
        }, {
          lastPage: 1,
          currentPage: 1
        }))
        dispatch(setMultistoreSelected(store));
        dispatch(clearProducts());
        if (location.pathname === routesEndpoints.NEW_CHECKOUT) {
          dispatch(uploadCheckout());
        }
      }
      dispatch(openShowModal(false));
    } else {
      dispatch(storeSelectedRequest(store));
      onSetaddressSelect({ id: store.store_id, type: 'addressStore' });
      onSetSelShipping(true);
    }
  }, [dispatch, onSetSelShipping, onSetaddressSelect, location.pathname, multistoreSelected.store_id]);

  if (loading) {
    return (<Loading size={160} bShowText />);
  }

  return (
    <Container>
      <ContainerAddress>
        <ContainerAddressList>
          {stores && stores.map((store, index) => (
              <ContainerAddressRow key={store.store_id} id={`store-${index + 1}`} onClick={() => handleadSelectStore(store)}>
                <AddressName>
                  <span>{store.name}</span>
                  {/* <span>5.1 km</span> */}
                </AddressName>
                <AddressAddress>{store.address}, {store.number} - {store.neighborhood} - {store.city} - {store.state} - CEP: {store.zip_code}</AddressAddress>
              </ContainerAddressRow>
          ))}
        </ContainerAddressList>
      </ContainerAddress>
    </Container>
  );
}

export default AddressStoreModal;
